import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import {getTranslation} from "../../helpers/get-translation";


const styles = theme => ({
	root: {
		display: "flex",
		width: "100%",
		padding: "16px"
	},
	imageContainer: {
		marginLeft: "15px",
		position: "relative",
		flex: "0 0 auto",
		width: "55px",
	},
	playerImage: {
		height: "55px",
		width: "55px",
		"border-radius": "50px",
	},
	countryImage: {
		"position": "absolute",
		"bottom": "3px",
		"right": "-1px",
		"border-radius": "50px",
		"width": "17px",
		"height": "17px",
	},
	dataContainer: {
		marginLeft: "15px",
		flex: "1 1 auto",
		maxWidth: "60%",
	},
	playerName:{
		textOverflow: "ellipsis",
		width: "100%",
		whiteSpace: "nowrap",
		overflow: "hidden",
	},
	playerScore:{
		fontSize: "13px",
		color: "#595959"
	},
	rankContainer: {
		marginLeft: "auto",
		marginRight: "20px",
		flex: "0 0 auto",

		"& > div": {
			display: "inline",
			width: "20px",
			height: "20px",
			paddingRight: "5px",
		},

		"& img": {
			width: "20px",
			height: "20px",
		}
	},
	//TODO max width 450
	"@media (max-width: 450px)": {
		root:{
			padding: "16px 8px"
		},
		imageContainer:{
			marginLeft: "0px"
		},
		playerImage:{
			height: "50px",
			width: "50px"
		},
		rankContainer:{
			marginRight: "8px",
		}
	},
	"@media (max-width: 380px)":{
		dataContainer: {
			maxWidth: "55%",
		}
	}
});

function Player(props){
	const { classes, playerData, rank, scoreName } = props;

	return (
		<div className={classes.root}>
			<div className={classes.imageContainer}>
				<img className={classes.playerImage} src={playerData.img} onError={(e) => {e.target.onerror = null; e.target.src=getTranslation("image_ranking_temp")}}/>
				<img className={classes.countryImage} src={getTranslation("flag_url", [playerData.country.toUpperCase()])}/>
			</div>
			<div className={classes.dataContainer}>
				<div className={classes.playerName}>{playerData.name}</div>
				<div className={classes.playerScore}>{playerData.score} {scoreName}</div>
			</div>
			<div className={classes.rankContainer}>
				<div>
					{rank === 1 && <img src={getTranslation("image_ranking_gold")}/>}
					{rank === 2 && <img src={getTranslation("image_ranking_silver")}/>}
					{rank === 3 && <img src={getTranslation("image_ranking_bronze")}/>}
				</div>
				{rank && <span>{getTranslation("ranking_score_player_rank")} {rank}</span>}
			</div>
		</div>



	);


}

Player.propTypes = {
	rank: PropTypes.number,

	scoreName: PropTypes.string.isRequired,
	playerData: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Player);
